import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const sessionId = m[1];
    (async () => {
      try {
        // Forward any pending referral code stashed by the Register page's
        // Google button click so Google signups also get credited to the
        // referrer. Clears immediately after use so it can't leak to a
        // second unrelated Google sign-in on the same device.
        let refCode = null;
        try {
          refCode = sessionStorage.getItem("rf_pending_ref");
          if (refCode) sessionStorage.removeItem("rf_pending_ref");
        } catch { /* ignore */ }
        const body = { session_id: sessionId };
        if (refCode) body.referral_code = refCode;
        const { data } = await api.post("/auth/emergent/session", body);
        // Store the bearer token so subsequent reloads can authenticate via
        // Authorization header even if the httpOnly cookie is blocked by the
        // browser (Safari ITP, third-party cookie restrictions, etc).
        if (data.session_token) {
          localStorage.setItem("rf_token", data.session_token);
        }
        setUser(data.user);
        // Consume any stashed post-auth redirect (e.g. `/import?job=X&auto_commit=1`)
        // saved by Login/Register before bouncing to Emergent Auth. This is what
        // makes the post-signup auto-commit hand-off work for Google signups.
        let nextPath = "/dashboard";
        try {
          const stashed = sessionStorage.getItem("rf_pending_next");
          if (stashed) {
            sessionStorage.removeItem("rf_pending_next");
            // Basic safety: only allow same-origin absolute paths.
            if (typeof stashed === "string" && stashed.startsWith("/") && !stashed.startsWith("//")) {
              nextPath = stashed;
            }
          }
        } catch { /* ignore */ }
        // Strip hash before navigating so React Router routes cleanly.
        window.history.replaceState(null, "", nextPath);
        navigate(nextPath, { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?error=oauth_failed", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 border-4 border-rf-amber border-t-rf-orange rounded-full animate-spin" />
        <p className="text-rf-ink-soft">Signing you in…</p>
      </div>
    </div>
  );
}
